module.exports = __webpack_public_path__ + "static/media/date-range-icon.769e290e.svg";